export default __webpack_public_path__ + "4b7fc01abbac4ceeffebbaf28564d71b.png";